export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";